import { assertUnreachable, FormatedFeatureType } from "shared";

type FeatureLabelKey =
  | "qrl.panel.features.fold"
  | "qrl.panel.features.fold_angle"
  | "qrl.panel.features.side"
  | "qrl.panel.features.hole.circular"
  | "qrl.panel.features.hole.slotted"
  | "qrl.panel.features.hole.complex"
  | "qrl.panel.features.hole.folded"
  | "qrl.panel.features.hole.simple";

type FeatureDisplay = {
  labelKey: FeatureLabelKey;
  properties: string[];
};

export const getFeatureDisplay = (feature: FormatedFeatureType): FeatureDisplay => {
  switch (feature.type) {
    case "Folding":
      if (!feature.angle) {
        return {
          labelKey: "qrl.panel.features.fold",
          properties: [],
        };
      }

      return {
        labelKey: "qrl.panel.features.fold_angle",
        properties: [`${feature.angle}°`],
      };
    case "Side":
      return {
        labelKey: "qrl.panel.features.side",
        properties: [`${feature.length}mm`],
      };
    case "Hole":
      return getHoleDisplay(feature);
    default:
      return assertUnreachable(feature);
  }
};

const getHoleDisplay = (
  feature: Extract<FormatedFeatureType, { type: "Hole" }>,
): FeatureDisplay => {
  switch (feature.subType) {
    case "hole_circular":
      return {
        labelKey: "qrl.panel.features.hole.circular",
        properties: [`ø${feature.diameter}`],
      };
    case "hole_slotted":
      return {
        labelKey: "qrl.panel.features.hole.slotted",
        properties: [`ø${feature.diameter}`],
      };
    case "hole_complex":
      return {
        labelKey: "qrl.panel.features.hole.complex",
        properties: [`${feature.edgeLength}mm`],
      };
    case "hole_folded":
      return {
        labelKey: "qrl.panel.features.hole.folded",
        properties: [`${feature.edgeLength}mm`],
      };
    default:
      return assertUnreachable(feature);
  }
};
